import styled from 'styled-components';

export const Description = styled.p`
  margin-bottom: 16px;
  font-size: 12px;
`;
